import { defaultThemeColors } from './defaultThemeColors';
export var defaultButtonVariants = {
    primary: {
        backgroundColor: defaultThemeColors.primary,
        color: defaultThemeColors.white,
        '&:hover': {
            backgroundColor: defaultThemeColors.primaryLight,
        },
        '&:active': {
            backgroundColor: defaultThemeColors.primaryDark,
        },
        '&:disabled': {
            backgroundColor: defaultThemeColors.primaryLightest,
        },
    },
    primaryText: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: defaultThemeColors.primary,
        '&:hover': {
            color: defaultThemeColors.primaryDark,
        },
    },
    secondary: {
        backgroundColor: 'transparent',
        borderColor: defaultThemeColors.primary,
        color: defaultThemeColors.primary,
        '&:hover': {
            backgroundColor: defaultThemeColors.primary,
            color: defaultThemeColors.white,
        },
        '&:active': {
            backgroundColor: defaultThemeColors.primaryDark,
            color: defaultThemeColors.white,
        },
        '&:disabled': {
            borderColor: defaultThemeColors.primaryLightest,
            color: defaultThemeColors.primaryLightest,
        },
    },
    tertiary: {
        backgroundColor: 'transparent',
        borderColor: defaultThemeColors.greyDark,
        color: defaultThemeColors.secondary,
        '&:hover': {
            backgroundColor: defaultThemeColors.greyLightest,
        },
        '&:active': {
            backgroundColor: defaultThemeColors.greyLight,
        },
        '&:disabled': {
            backgroundColor: defaultThemeColors.white,
        },
    },
    grey: {
        backgroundColor: defaultThemeColors.white,
        borderColor: defaultThemeColors.grey,
        color: defaultThemeColors.greyDarkest,
        '&:hover': {
            borderColor: defaultThemeColors.greyDark,
        },
        '&:active': {
            backgroundColor: defaultThemeColors.greyLight,
        },
        '&:disabled': {
            borderColor: defaultThemeColors.grey,
            color: defaultThemeColors.grey,
        },
    },
    greyText: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: defaultThemeColors.grey,
        '&:hover': {
            color: defaultThemeColors.greyDark,
        },
    },
    success: {
        color: defaultThemeColors.white,
        backgroundColor: defaultThemeColors.secondary,
        '&:hover': {
            backgroundColor: defaultThemeColors.secondaryLight,
        },
        '&:active': {
            backgroundColor: defaultThemeColors.secondaryDark,
        },
        '&:disabled': {
            backgroundColor: defaultThemeColors.secondaryLightest,
        },
    },
    warning: {
        backgroundColor: defaultThemeColors.orange,
        color: defaultThemeColors.white,
        '&:hover': {
            backgroundColor: defaultThemeColors.orangeLight,
        },
        '&:active': {
            backgroundColor: defaultThemeColors.orangeDark,
        },
        '&:disabled': {
            backgroundColor: defaultThemeColors.orangeLightest,
        },
    },
    danger: {
        backgroundColor: defaultThemeColors.red,
        color: defaultThemeColors.white,
        '&:hover': {
            backgroundColor: defaultThemeColors.redLight,
        },
        '&:active': {
            backgroundColor: defaultThemeColors.redDark,
        },
        '&:disabled': {
            backgroundColor: defaultThemeColors.redLightest,
        },
    },
    info: {
        backgroundColor: defaultThemeColors.blue,
        color: defaultThemeColors.white,
    },
    container: {
        background: 'none',
        borderColor: 'transparent',
    },
};
//# sourceMappingURL=defaultButtonVariants.js.map